<template>
  <StatIcon>
    <template #statNumber>
      {{ topHalf }}
    </template>
    <template #statUnits>
      {{ bottomHalf }}
    </template>
  </StatIcon>
</template>

<script>
import StatIcon from '../components/stat-icon'

export default {
  components: { StatIcon },

  props: {
    date: {
      type: String,
      required: true
    }
  },
  computed: {
    // We show this shortened date icon differently for different languages.
    // E.g., in English, the top half will be a number which is the day
    // of the month, and the bottom half will be the abbreviated name
    // of the month.
    topHalf() {
      return this.i18n.l('time.formats.calendar_icon_top_half', this.date)
    },
    bottomHalf() {
      return this.i18n.l('time.formats.calendar_icon_bottom_half', this.date)
    }
  }
}
</script>
